import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { AvForm, AvInput } from 'availity-reactstrap-validation'
import { getOperatorName } from '../../../actions/dashboardAction'
import { Row, Col, Card, CardHeader, CardBody, Button, FormGroup, Table, InputGroup, InputGroupAddon, InputGroupText, CardFooter, Pagination, PaginationItem, PaginationLink } from 'reactstrap'

class OperatorName extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start: 0,
      curPage: 1,
      perPage: 10,
      nama_operator: ''
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      length: 10
    }

    this.props.getOperatorName(data)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        nama_operator: this.state.nama_operator,
      }

      if (this.state.curPage === undefined) {
        data.start = this.state.start
      } else {
        let offset = (this.state.curPage * 10) - 10
        data.start = offset
      }

      this.props.getOperatorName(data)
    }
  }

  handleClick(e) {
    this.setState({ curPage: e })
  }

  handleFilter(event, values) {
    this.setState({ nama_operator: values.nama_operator })
    values.length = this.state.perPage

    this.props.getOperatorName(values)
  }

  render() {
    if (this.props.operatorNameHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    if (this.props.operatorNameIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }

  renderData() {
    if (this.props.operatorNameIsSuccess) {
      let defaultValues = {
        nama_operator: this.state.nama_operator
      }

      const prevPage = parseInt(this.props.operatorName.currentPage) - 1
      const nextPage = parseInt(this.props.operatorName.currentPage) + 1

      let curPage = this.props.operatorName.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2

      const pages = []
      const totalPages = this.props.operatorName.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>Daftar Nama Operator</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Nama Operator</InputGroupText>
                        </InputGroupAddon>
                        <AvInput type="text" name="nama_operator" />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1">
                        <i className="fa fa-search"></i> <span>Proses</span>
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody className="p-0">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th><strong>Nama Perusahaan</strong></th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.operatorName.data.map((item) => (
                    <tr key={item.id}>
                      <td>{item.nama_perusahaan}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
            <CardFooter>
              <Pagination>
                {this.props.operatorName.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(1)}>
                      First Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.operatorName.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(prevPage)}>
                      Prev
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {pages.map((item, index) => {
                  let actived = false
                  if (curPage === undefined) {
                    curPage = 1
                  }

                  if (item == curPage) {
                    actived = true
                  }

                  if (item >= minPage && item <= maxPage) {
                    return <PaginationItem active={actived} key={index}>
                      <PaginationLink tag="button" onClick={(e) => this.handleClick(item)}>
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                  }
                })}

                {this.props.operatorName.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(nextPage)}>
                      Next
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.operatorName.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(totalPages)}>
                      Last Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }
              </Pagination>

              {this.props.operatorName.pageTotal > 0 &&
                <p>Page: {this.props.operatorName.currentPage} of {this.props.operatorName.pageTotal}</p>
              }
            </CardFooter>
          </Card>
        </div>
      )
    }
  }
}

OperatorName.propTypes = {
  operatorNameIsSuccess: PropTypes.bool.isRequired,
  operatorNameHasError: PropTypes.bool.isRequired,
  operatorNameIsLoading: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  return {
    operatorName: state.dashboard.operatorName,
    operatorNameIsSuccess: state.dashboard.operatorNameSuccess,
    operatorNameHasError: state.dashboard.operatorNameError,
    operatorNameIsLoading: state.dashboard.operatorNameLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getOperatorName: (data) => dispatch(getOperatorName(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OperatorName)